import { FileExtension, FileExtensions, ImageFileExtensions, VideoFileExtensions } from "../DTOs";
import { basicValidation } from "../modules";
import { rng } from "../util";


export const fileNameHelper = {
    isValidPrivateFileName:(fileName:string) => basicValidation.isValidFileName(fileName, 128),
    isValidPublicFileName:(fileName:string) => basicValidation.isValidFileName(fileName, 256),
    isSupportedFileExtension: (fileName:string) => isSupportedFileExtension(fileName),
    getSupportedFileExtension,
    isImageFile: (fileName:string) => isImageFile(fileName),
    isVideoFile: (fileName:string) => isVideoFile(fileName),
    getNameSections: (fileName:string) => getNameSections(fileName),
    generateName: (extension:string) => generateName(extension)
};

function generateName(extension:string)
{
    if(!FileExtensions.find(x => x === extension))
        throw new Error('Invalid file extension: ' + extension);

    return rng.getRandomId() + '.' + extension;
}

function getNameSections(fileName: string)
{
    if(!basicValidation.isValidFileName(fileName, 256))
        throw new Error('Invalid file name: ' + fileName);

    const extensionSplitIndex = fileName.lastIndexOf('.');
    
    return {
        name:fileName.substring(0, extensionSplitIndex),
        extension:fileName.substring(extensionSplitIndex+1)
    }
}

function isSupportedFileExtension(fileName: string): boolean
{
    if(!basicValidation.isValidFileName(fileName, 256))
        return false;

    return FileExtensions.some(i => getNameSections(fileName).extension === i);
}

function getSupportedFileExtension(fileName: string): FileExtension
{
    if(!isSupportedFileExtension(fileName))
        throw new Error('Unsupported file extension: ' + fileName);

    return getNameSections(fileName).extension as FileExtension;
}

function isImageFile(fileName:string): boolean
{
    return ImageFileExtensions.some(i => getNameSections(fileName).extension === i);
}

function isVideoFile(fileName:string): boolean
{
    return VideoFileExtensions.some(i => getNameSections(fileName).extension === i);
}